import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Card-level interactions can be added here
  }

  // Future: Add inline editing, quick actions, etc.
}
